import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import componentsUS from '@app/common/locales/components-en_US.json';

export function initializeI18n(): void {
  i18n.use(initReactI18next).init({
    resources: {
      en_US: { translation: { components: componentsUS } }
    },
    lng: 'en_US',
    fallbackLng: 'en_US',
    interpolation: { escapeValue: false }
  });
}
